import { Box, TextField } from "@mui/material";
import { useState } from "react";
import FormModalActions from "./FormModalActions";
import MyModal from "./MyModal";

interface ISSHReasonModal {
  open: boolean;
  action: "start" | "stop";
  loading?: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

export default function SSHReasonModal({ open, action, loading, onClose, onConfirm }: ISSHReasonModal) {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const title = action === "start" ? "Start SSH" : "Stop SSH";

  const submit = () => {
    const trimmed = reason.trim();
    if (trimmed.length < 10) {
      setError("Enter a reason of at least 10 characters.");
      return;
    }
    setError("");
    onConfirm(trimmed);
  };

  return (
    <MyModal
      title={title}
      subtitle="This action is audited. Provide a short reason for the record."
      open={open}
      setOpen={(next) => {
        if (!next) {
          setReason("");
          setError("");
          onClose();
        }
      }}
      variant="light"
      width={440}
    >
      <Box display="flex" flexDirection="column" gap={2}>
        <TextField
          label="Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          minRows={2}
          fullWidth
          autoFocus
          error={Boolean(error)}
          helperText={error || "Minimum 10 characters"}
          placeholder="Support ticket #… / device recovery…"
        />
        <FormModalActions
          onCancel={onClose}
          cancelLabel="Cancel"
          submitLabel={action === "start" ? "Start SSH" : "Stop SSH"}
          submitType="button"
          onSubmit={submit}
          loading={loading}
        />
      </Box>
    </MyModal>
  );
}
